import { render } from "./HealthDataModal.vue?vue&type=template&id=ef4c9da2"
import script from "./HealthDataModal.vue?vue&type=script&lang=js"
export * from "./HealthDataModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__